<template>
  <span
    ><i
      class="fs-xl fa"
      v-for="val in [1, 2, 3, 4, 5]"
      :class="starClass(val)"
      :key="val"
    ></i
  ></span>
</template>

<script>
export default {
  name: 'ratingStars',
  props: {
    starExtraClass: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    starClass(val) {
      if (this.value >= val) {
        return 'fa-star ' + this.starExtraClass;
      } else if (this.value > val - 1 && this.value < val) {
        return 'fa-star-half-o ' + this.starExtraClass;
      } else {
        return 'fa-star-o ' + this.starExtraClass;
      }
    },
  },
};
</script>
